import React from "react";
import { useNavigate } from "react-router-dom";
import { BannerWrapper } from "../../styles/StyledComponents/BannerWrapper";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { IBannerProps } from "../../ui/interface";

const BannerComp: React.FC<IBannerProps> = ({
  description,
  image,
  istagTitle,
  title,
  ...props
}) => {
  const navigate = useNavigate();

  return (
    <BannerWrapper {...props}>
      <div className="bannerInner">
        <figure>
          <img src={image} alt="bannerImg" />
        </figure>
        <div className="container">
          <div className="banner_text">
            {title && (
              <h1>
                {istagTitle && <span>{istagTitle}</span>}
                {title}
              </h1>
            )}
            <div className="banner_details_box">
              {description && <p>{description}</p>}
              <div className="btnWrap">
                <CommonButton
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  Contact Us
                </CommonButton>
                <CommonButton variant="contained" color="primary">
                  Join Our Team
                </CommonButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BannerWrapper>
  );
};

export default BannerComp;
